import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, offeringsService } from '@v2/services';

export const useRemoveBitwerxOffering = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: offeringsService.removeBitwerxOffering,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.offerings.bitwerx.all);
    },
  });

  const deleteBitwerxOffering = async (offeringId: string): Promise<string | null> => {
    if (!offeringId?.trim()) return null;
    try {
      return await mutation.mutateAsync(offeringId);
    } catch {
      return null;
    }
  };

  return {
    deleteBitwerxOffering,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useRemoveBitwerxOffering;
